var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.hasOpenComponentsArr),function(item){return _c(item.name,{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name === item.name),expression:"$route.name === item.name"}],key:item.name,tag:"component"})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }